const possibleItems: { [link: string]: string } = {
    "/home": "Home",
    "/home/dashboard": "Dashboard",
    "/home/dashboard/balance": "Balance",
    "/home/dashboard/balance/minutes": "Minutes",
    "/home/dashboard/balance/money": "Money",
    "/home/dashboard/balance/minutes/order": "Order",
    "/home/dashboard/balance/minutes/sales-record": "Sales",
    "/home/dashboard/balance/minutes/orders-record": "Orders",
    "/home/dashboard/balance/minutes/sell": "Sell",
    "/home/dashboard/balance/money/transfer": "Transfer",
    "/home/dashboard/balance/money/view-transfers": "Transfers",
    "/home/settings": "Settings",
    "/home/dashboard/jobs": "Job",
    "/home/dashboard/balance/money/add": "Add Money",
    "/home/desktop-login": "Desktop Login",
    "/home/account-setup": "Account Setup",
    "/home/feedback": "Feedback",
    "/home/files": "Files",
    "/home/files/create-job": "Create Job",
    "/home/teams": "Teams",
    "/home/teams/team": "Team",
};

const breadcrumbsSelector = (
    state: sage.state.IRedux
): sage.model.IBreadcrumb[] => {
    const pathName = state.router.location.pathname;
    const segments = pathName.split("/");
    const combinedSegments = [];
    for (let i = 1; i < segments.length; i++) {
        let output = "";
        for (let j = 1; j <= i; j++) {
            output += "/";
            output += segments[j];
        }
        combinedSegments.push(output);
    }

    return combinedSegments
        .filter((seg) => seg in possibleItems)
        .map((seg) => ({
            link: seg,
            name: possibleItems[seg],
        }));
};

export default breadcrumbsSelector;
